<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>Modifier le mot de passe</v-card-title>
        <v-card-text>
          <v-text-field v-model="oldPassword" label="Ancien mot de passe" type="password" required />
          <v-text-field v-model="newPassword" label="Nouveau mot de passe" type="password" required />
        </v-card-text>
        <v-card-actions>
          <v-btn @click="updatePassword">Mettre à jour</v-btn>
          <v-btn @click="$emit('close')">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script setup>
  import { ref } from 'vue';
  import { useAuthStore } from '@/store/AuthStore';
import snackbarService from '@/services/snackbarService';
  const dialog = ref(true);
  const oldPassword = ref('');
  const newPassword = ref('');
  const authStore = useAuthStore();
  
  const updatePassword = async () => {
    try {
        await authStore.updatePassword(authStore.user.email, oldPassword.value, newPassword.value)
        snackbarService.showSnackbar("Mot de passe mis à jour avec succès.", 'success')
      dialog.value = false;
    } catch (error) {
      snackbarService.showSnackbar(error, 'error')
    }
  };
  </script>